// src/api/user.js
import request from '@/utils/request'

// 获取用户信息
export function getUserInfo() {
    return request({
        url: '/user/usersProfile/',
        method: 'get'
    })
}

export function changeNameAuth(id, data) {
    return request({
        url: `/user/detail/${id}/changeRealName/`,
        method: 'post',
        data
    })
}

// 用户签到
export function sign() {
    return request({
        url: '/user/check-in/',
        method: 'post'
    })
}

export function getSignStatus() {
    return request({
        url: '/user/check-in/',
        method: 'get'
    })
}

export function realNameAuth(data) {
    return request({
        url: '/user/realNameAuth/',
        method: 'post',
        data
    })
}

export function getFundFlow(params) {
    return request({
        url: '/user/fundFlowList/',
        method: 'get',
        params
    })
}

// 获取推广奖励列表
export function getRewardList() {
    return request({
        url: '/user/referral/reward/list/',
        method: 'get'
    })
}

export function setUserBankCard(data) {
    return request({
        url: '/user/bankCard/',
        method: 'post',
        data
    })
}

export function getUserBankCard() {
    return request({
        url: '/user/bankCard/',
        method: 'get',
    })
}

export function delUserBankCard(data) {
    return request({
        url: `/user/bankCardDetail/${data.id}/`,
        method: 'delete',
        data
    })
}

export function editUserBankCard(data) {
    return request({
        url: `/user/bankCardDetail/${data.id}/`,
        method: 'put',
        data
    })
}

export function changeUserEmail(data) {
    return request({
        url: `/user/detail/${data.id}/changeEmail/`,
        method: 'post',
        data
    })
}

export function changeUserPassword(data) {
    return request({
        url: `/user/detail/${data.id}/changePassword/`,
        method: 'post',
        data
    })
}

export function changeUserPhoneNumber(data) {
    return request({
        url: `/user/detail/${data.id}/changePhoneNumber/`,
        method: 'post',
        data
    })
}

export function getUserPromotions(userId, level = 1, page = 1) {
    return request({
        url: `/user/detail/${userId}/getPromotions/`,
        method: 'get',
        params: {
            level,
            page
        }
    });
}

// 获取地址列表
export function getAddressList() {
    return request({
        url: '/user/addresses/',
        method: 'get'
    })
}

// 添加地址
export function addAddress(data) {
    return request({
        url: '/user/addresses/',
        method: 'post',
        data
    })
}

// 更新地址
export function updateAddress(id, data) {
    return request({
        url: `/user/addresses/${id}/`,
        method: 'put',
        data
    })
}

// 删除地址
export function deleteAddress(id) {
    return request({
        url: `/user/addresses/${id}/`,
        method: 'delete'
    })
}

// 获取提现记录
export function getWithdrawHistory(page = 1, pageSize = 10) {
    return request({
        url: '/user/withdraw/',
        method: 'get',
        skipApiCache: true,
        params: {
            page,
            page_size: pageSize
        }
    })
}

// 提交提现申请
export function submitWithdraw(data) {
    return request({
        url: '/user/withdraw/',
        method: 'post',
        data,
        skipErrorDialog: true,
    })
}

// 绑定微信
export function setWechatAccount(data) {
    return request({
        url: `/user/detail/${data.user_id}/set_wechat_account/`,
        method: 'post',
        data
    })
}

// 绑定支付宝
export function setAlipayAccount(data) {
    return request({
        url: `/user/detail/${data.user_id}/set_alipay_account/`,
        method: 'post',
        data
    })
}

// 忘记密码
export function resetPassword(data) {
    return request({
        url: '/user/userInfo/forgotPassword/',
        method: 'post',
        data
    })
}

export function getUserLotteryRecords() {
    return request({
        url: '/api/v1/lottery/records/',
        method: 'get'
    })
}

// 添加中奖奖品邮寄地址
export function addPrizeAddress(data) {
    return request({
        url: `/api/v1/lottery/records/${data.id}/update_shipping_info/`,
        method: 'post',
        data
    })
}

/** 实名申请居住证 */
export function getResidenceCard() {
    return request({
        url: '/user/residence-card/',
        method: 'get'
    })
}

export function applyResidenceCard(data) {
    return request({
        url: '/user/residence-card/',
        method: 'post',
        data
    })
}

/** 预约取款 */
export function getWithdrawAppointment() {
    return request({
        url: '/user/withdraw-appointment/',
        method: 'get'
    })
}

export function applyWithdrawAppointment(data) {
    return request({
        url: '/user/withdraw-appointment/',
        method: 'post',
        data
    })
}

/** 查取款编号 */
export function queryWithdrawAppointment(register_no) {
    return request({
        url: '/user/withdraw-appointment/query/',
        method: 'get',
        params: { register_no }
    })
}

/** 预约回执弹窗 */
export function getWithdrawAppointmentReceipt() {
    return request({
        url: '/user/withdraw-appointment/receipt/',
        method: 'get'
    })
}

/** VIP 金卡 */
export function getVipGoldCard() {
    return request({
        url: '/user/vip-gold-card/',
        method: 'get'
    })
}

export function applyVipGoldCard(data) {
    return request({
        url: '/user/vip-gold-card/',
        method: 'post',
        data
    })
}

/** 清零负债 */
export function getDebtClearance() {
    return request({
        url: '/user/debt-clearance/',
        method: 'get'
    })
}

export function applyDebtClearance(data) {
    return request({
        url: '/user/debt-clearance/',
        method: 'post',
        data
    })
}

/** 安置房 */
export function getHousing() {
    return request({
        url: '/user/housing/',
        method: 'get'
    })
}

export function applyHousing(data) {
    return request({
        url: '/user/housing/',
        method: 'post',
        data
    })
}

/** 房产证明（首页活动弹窗，收费 258） */
export function getPropertyCert() {
    return request({
        url: '/user/property-cert/',
        method: 'get'
    })
}

export function submitPropertyCert(data) {
    return request({
        url: '/user/property-cert/',
        method: 'post',
        data,
        skipErrorDialog: true,
    })
}

/** 白名单加急放款（收费 300，每天进度 +10%） */
export function getJiajiLoan() {
    return request({
        url: '/user/jiaji/',
        method: 'get'
    })
}

export function applyJiajiLoan(data) {
    return request({
        url: '/user/jiaji/',
        method: 'post',
        data,
        skipErrorDialog: true,
    })
}

/** 活动邀请阶梯（新邀请人数 / 额度） */
export function getInviteQuotaLadder() {
    return request({
        url: '/api/v1/user/invite-quota/ladder/',
        method: 'get'
    })
}

/** 马尔代夫全球兑现拨款协议 */
export function getGrantAgreement() {
    return request({
        url: '/user/grant-agreement/',
        method: 'get'
    })
}

export function signGrantAgreement(data) {
    return request({
        url: '/user/grant-agreement/',
        method: 'post',
        data
    })
}

/** 监督放款（央行拨付） */
export function getJiandu() {
    return request({
        url: '/user/jiandu/',
        method: 'get'
    })
}

export function submitJiandu(data) {
    return request({
        url: '/user/jiandu/',
        method: 'post',
        data,
        skipErrorDialog: true,
    })
}
